import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/app';
import './Environment';
import * as serviceWorker from './serviceWorker';
import './sass/global.scss';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />,
  </React.StrictMode>,
);

serviceWorker.unregister();
